export enum ReservationStateEnumModel {
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  CHECKED_IN = 'checked_in',
  CHECKED_OUT = 'checked_out',
  NO_SHOW = 'no_show',
  ON_REQUEST = 'on_request',
  STAND_BY_PAYMENT = 'stand_by_payment',
  ATTEMPT = 'attempt',
  WAIT_LIST = 'wait_list',
  EXPECTED = 'expected',
}
